<template>
  <v-row class="ma-0">
    <v-col
      cols="6"
      sm="6"
      md="6"
      class="pt-0 pb-0"
    >
      <v-text-field
        :model-value="familyName"
        variant="outlined"
        hide-details
        label="姓"
        @update:model-value="$emit('update:family-name', $event)"
      />
    </v-col>
    <v-col
      cols="6"
      sm="6"
      md="6"
      class="pt-0 pb-0"
    >
      <v-text-field
        :model-value="firstName"
        variant="outlined"
        hide-details
        label="名"
        @update:model-value="$emit('update:first-name', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "DaytimeAdviceDoctorNameConditionInput",
  props: {
    familyName: {
      type: String,
      default: null
    },
    firstName: {
      type: String,
      default: null
    }
  },
  emits: ["update:family-name", "update:first-name"]
};
</script>
